import { twc } from 'react-twc';

import { cn } from '@/utils/twx';

import { CommonButton, CommonButtonProps } from './CommonButton';

export const BaseContainedButton = twc(CommonButton)`${cn(
  'text-white bg-opacity-100 hover:bg-opacity-80 active:bg-opacity-100 focus-within:bg-opacity-100 transition-all duration-300',
  'disabled:bg-opacity-60 disabled:cursor-not-allowed disabled:hover:bg-opacity-60',
)} `;
export const PrimaryContainedButton = twc(BaseContainedButton)`bg-primary active:bg-primary-accent`;

export const SecondaryContainedButton = twc(
  BaseContainedButton,
)`bg-secondary active:bg-secondary-accent`;

export const BlackContainedButton = twc(BaseContainedButton)`bg-gray-1 active:bg-gray-3`;

const ContainedButton = ({ color, ...props }: CommonButtonProps) => {
  switch (color) {
    case 'primary':
      return <PrimaryContainedButton {...props} />;
    case 'secondary':
      return <SecondaryContainedButton {...props} />;
    default:
      return <BlackContainedButton {...props} />;
  }
};

export default ContainedButton;
